import { useAuthStore } from '~/store/auth';

const restrictedRoutesLoggedOut = [
    'account',
    'favorites',
    'uploads',
    'upload-checklist',
    'upload-preview',
    'upload-uploading',
    'upload-video',
    'upload-thank-you',
];

const restrictedRoutesIsSponsor = [
    'uploads',
    'upload-checklist',
    'upload-preview',
    'upload-uploading',
    'upload-video',
    'upload-thank-you',
];

export default defineNuxtRouteMiddleware((to) => {
    const authStore = useAuthStore();

    if (!authStore.loggedIn) {
        if (restrictedRoutesLoggedOut.includes(to.name)) {
            return '/';
        }
    }

    if (authStore.isSponsor) {
        if (restrictedRoutesIsSponsor.includes(to.name)) {
            return '/';
        }
    }
});
